function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import BadgeComponent from "components/core/badge/badge-component";
import { HEADER_SUBMENU_LINK_CLICKED } from "/constants/bigbrain-event-types";
import RightArrow from "/static/svg/arrow-right2.svg";
import { StyledHeaderMenuItemComponent } from "./header-menu-item-component.scss";
class HeaderMenuItemComponent extends PureComponent {
    render() {
        const { icon: Icon, title, description, url, isPopular, translate, footer } = this.props;
        return /*#__PURE__*/ _jsx(StyledHeaderMenuItemComponent, {
            className: "header-menu-item-component",
            href: url,
            onClick: this.onClick,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "header-menu-item-content",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        className: "menu-item-title-icon"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "menu-item-text-wrapper",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "menu-item-title-wrapper",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "menu-item-title",
                                        children: translate(title)
                                    }),
                                    isPopular && /*#__PURE__*/ _jsx("div", {
                                        className: "new-badge-component-wrapper",
                                        children: /*#__PURE__*/ _jsx(BadgeComponent, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "menu-item-description",
                                children: translate(description)
                            }),
                            footer && /*#__PURE__*/ _jsxs("span", {
                                className: "menu-item-footer",
                                children: [
                                    translate(footer),
                                    " ",
                                    /*#__PURE__*/ _jsx(RightArrow, {})
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "onClick", (e)=>{
            const { url } = this.props;
            const isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", HEADER_SUBMENU_LINK_CLICKED, {
                kind: url,
                info1: isKeyboardEvent ? "keyboard" : "mouse"
            });
        });
    }
}
export default withGenericConfig(HeaderMenuItemComponent);
